import { useQuery } from '@tanstack/react-query'

import { GetSimulacoesRelacionadas } from '@/features/simulacao/services/get-simulacoes-relacionadas.service'
import { simulacaoKeys } from '@/features/simulacao/utils/queries'

export const useSimulacoesRelacionadas = (idSimulacaoPrincipal: string) => {
  return useQuery({
    queryKey: simulacaoKeys.listaSimulacoesRelacionadas(idSimulacaoPrincipal),
    queryFn: async () => new GetSimulacoesRelacionadas().execute(idSimulacaoPrincipal).then((res) => res.data),
    gcTime: 0,
    enabled: false,
  })
}
